var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('user-view-form'),_c('user-probes'),(_vm.user.role === 'super_admin')?_c('user-permissions'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }